import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import BOMForm from "../../../../components/MainForm/BOMForm";
import ParentBomsService from "../../../../services/parentboms.service";
import ChildBomsService from "../../../../services/childboms.service";

export default function CopyBOMInformation() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const handleSubmitParentBoms = ({ data }) => {
    setLoading(true);
    ParentBomsService.createParentBoms(data?.Parent)
      .then((response) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        const ChildBoms = {
          Array: data?.Child?.Array.map((item) => ({
            Parent_Bom_Id: response.generatedMaps[0].Id,
            Item_Child_Id: item.Item_Child_Id,
            Item_Child_Qty: item.Item_Child_Qty,
            Foc_Id: item.Foc_Id,
            Bom_Pm: item.Bom_Pm,
            Sub_Bom: item.Sub_Bom
          }))
        };
        handleSubmitChildBoms(ChildBoms);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitChildBoms = (data) => {
    setLoading(true);
    ChildBomsService.createChildBoms(data)
      .then((_) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        navigate(0);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Helmet>
        <title>{`คัดลอกข้อมูล BOM`}</title>
        <meta name="description" content={`Copy BOM Information Page`} />
      </Helmet>

      <Container fluid className="p-3">
        <BOMForm
          editData={{ type: "copy" }}
          onSubmitCallback={handleSubmitParentBoms}
        />
      </Container>
    </>
  );
}
